import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {IBigWinLevel} from "../interfaces/Interface";
import {gsap} from "gsap";
import {Sound} from "../sound/Sound";

export class BigWinRunner implements SimplePresentationRunner {
    shouldRun(): boolean {
        return Game.model.isBigWin && !Game.model.isXGodMaxWinTriggered();
    }

    start(controller: SimplePresentationRunnerController): void {
        const levels: IBigWinLevel[] = Game.model.getBigWinLevels(),
            tl: gsap.core.Timeline = new gsap.core.Timeline({
                onComplete: () => {
                    controller.finish();
                }
            });

        Game.bigWinView.maxLevel = levels[levels.length - 1].id;
        Game.bigWinView.visible = true;

        tl.add(() => {
            Game.bigWinView.playBlackBg();
            Game.bigWinView.playOldScreenEffect();
        }, 0);

        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = bigWinLevel.from * Game.model.gameData.playedBetValue,
                to: number = bigWinLevel.to * Game.model.gameData.playedBetValue;

            tl.add(() => {
                controller.setSkipCallback(() => {
                    Game.soundPlayer.stopBigWinSound();
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            });
            tl.add(Game.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id));
            tl.addLabel(bigWinLevel.type + "_end");
        }
        tl.add(() => {
            Game.bigWinView.stopOldScreenEffect();
            controller.setSkipCallback();
            Game.soundPlayer.playSound(Sound.BIGWIN_END);
            if (!Game.model.gameData.brokeTheBank) {
                Game.keypadPlugin.setWin(Game.model.gameData.accumulatedRoundWin, true, Game.isWinBelowStake());
            }
        });
        tl.to(this, {
            duration: 0.5
        });

        if (Game.model.gameData.brokeTheBank) {
            tl.add(() => {
                Game.reelView.hide();
                Game.blackBG.show(1);
            });
        } else {
            tl.add(Game.bigWinView.hide(0.6));
            tl.add(() => {
                if (Game.model.gameData.mode === "NORMAL" && Game.model.gameData.nextMode === "NORMAL") {
                    Game.soundPlayer.fadeSound(0, 1, 700, Sound.MAIN_GAME_MUSIC);
                    Game.soundPlayer.currentMusic = Sound.MAIN_GAME_MUSIC;
                } else {
                    Game.soundPlayer.fadeSound(0, 1, 700);
                }
            }, "<0.5");
        }
    }
}